export const CAREERS_SET_SELECTED = "CAREERS_SET_SELECTED"
export const CONTACT_SET_MESSAGE_SENT = "CONTACT_SET_MESSAGE_SENT"
export const CONTACT_SET_PANE_OPEN = "CONTACT_SET_PANE_OPEN"
export const CONTACT_SET_ERROR_MESSAGE = "CONTACT_SET_ERROR_MESSAGE"
export const NAVMENU_SET_PANE_OPEN = "NAVMENU_SET_PANE_OPEN"
export const SHARED_SET_NEWSLETTER_SUBMITTED = "SHARED_SET_NEWSLETTER_SUBMITTED"
export const SHARED_SET_SNACKBAR_OPEN = "SHARED_SET_SNACKBAR_OPEN"
